import styled from 'styled-components';

import { Column } from '../../shared/styles';

const NameColumn = styled(Column)`
  width: 50%;
`;

const DateColumn = styled(Column)`
  width: 12%;
`;

const ActionColumn = styled(Column)`
  width: 26%;
`;

export {
  ActionColumn,
  DateColumn,
  NameColumn,
};
